import { useDispatch } from 'react-redux';
import { Button } from '../../../../../../component';
import { advanceToStep, studiesSelector } from '../../../redux/studies.reducer';
import nls from '../../../nls/pt-BR.json';
import { useTypedSelector } from '../../../../../../hooks/useTypedSelector';
import { setDisplayCharts } from '../../../../redux/dashboardActions';

interface Props {
  callback?: () => void;
}

export const PreviousStepButton: React.FC<Props> = ({ callback }) => {
  const dispatch = useDispatch();
  const { currentStep, layoutsValuationSecondaryResponse } =
    useTypedSelector(studiesSelector);
  const handleClickReturn = () => {
    if (
      !layoutsValuationSecondaryResponse &&
      currentStep.nextStep === 'understandTransactions'
    ) {
      dispatch(advanceToStep('calculateInstallmentsPrimary'));
      return;
    }
    dispatch([
      advanceToStep(
        currentStep.previousStep ? currentStep.previousStep : 'initialState'
      ),
      setDisplayCharts(null),
    ]);
    if (callback) {
      callback();
    }
  };
  return (
    <Button
      className="btn normal secondary"
      cy="StudyCreationGuideReturn"
      style={{
        border: '1px solid black',
        borderRadius: 4,
        color: '#383939',
        fontWeight: 500,
      }}
      onClick={handleClickReturn}
    >
      {nls.studyCreationGuide.buttons.return}
    </Button>
  );
};
